export default "__VITE_ASSET__I7KlLR12__"